import { BottomSheetProps } from "@gorhom/bottom-sheet"
import { SwipeableDrawerProps } from "@mui/material"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { undefinedFunctionWarning } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../constants/i18n"

import { BottomSheet } from "../BottomSheet"

import * as Styled from "./FilterBottomSheet.styled"

export const FilterBottomSheet = (props: FilterBottomSheet) => {

    const {
        children,
        onOpen = undefinedFunctionWarning("onOpen"),
        title,
        ...bottomSheetProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    return <BottomSheet {...bottomSheetProps}
        disableDiscovery
        disableBackdropTransition
        disableSwipeToOpen
        disableEnforceFocus
        onOpen={onOpen}>
        <Styled.ContentWrapper>
            <Styled.Title variant="Desktop & Mobile/Heading/H2">{title || t(I18N_NAMESPACE, "components.filterBottomSheet.title")}</Styled.Title>
            {children}
        </Styled.ContentWrapper>
    </BottomSheet>
}

type FilterBottomSheet = BottomSheetProps & SwipeableDrawerProps & {
    onOpen?: () => void,
    open: boolean,
}